import React from 'react';
import { Smartphone } from 'lucide-react';

export default function ShreepujaTravelsLanding() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-16 gap-8">
          {/* Left side text */}
          <div className="lg:w-2/5">
            <p className="text-gray-600 text-lg leading-relaxed">
              At <span className="text-pink-600 font-bold" style={{ color: 'rgba(65, 1, 150, 1)' }}>Shree puja Travels</span> discover a smarter way to travel. Enjoy seamless bookings, reliable service, comfortable journeys, and personalized travel solutions that redefine convenience and make every trip memorable.
            </p>
          </div>
          
          {/* Right side heading */}
          <div className="lg:w-3/5 text-right">
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight">
              Experience Travel the{' '}
              <span className="text-pink-600"style={{ color: 'rgba(65, 1, 150, 1)' }}>Smarter Way</span>
            </h1>
          </div>
        </div>

        {/* Features Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {/* Card 1 */}
          <div className="bg-pink-50 rounded-3xl p-8">
            <div className="bg-pink-600 rounded-full w-20 h-20 flex items-center justify-center mb-6"style={{ background: 'rgba(65, 1, 150, 1)' }} >
              <Smartphone className="w-10 h-10 text-white"/>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              You're at the Heart of What We Do
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Every journey is built around your comfort, trust, and satisfaction.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-pink-50 rounded-3xl p-8">
            <div className="bg-pink-600 rounded-full w-20 h-20 flex items-center justify-center mb-6"style={{ background: 'rgba(65, 1, 150, 1)' }}>
              <Smartphone className="w-10 h-10 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Safety You Can Count On
            </h3>
            <p className="text-gray-600 leading-relaxed">
              From departure to arrival, your peace of mind is always protected.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-pink-50 rounded-3xl p-8">
            <div className="bg-pink-600 rounded-full w-20 h-20 flex items-center justify-center mb-6"style={{ background: 'rgba(65, 1, 150, 1)' }}>
              <Smartphone className="w-10 h-10 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Punctual Journeys, Always
            </h3>
            <p className="text-gray-600 leading-relaxed">
              We keep our promises reaching your destination on time, every time.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}